<template>
	<div>
		<ul class="circles-list">
			<li v-for="(item, index) in listData" :key="item.id">
				<div class="circles-top clearfix">
					<!-- <div class="circles-follow" v-if="mode_ === 1" @click="apimemberFollow(item.user.id, item.follow)">
						<img v-if="!item.follow" src="~@/assets/img/culturalCircles/add@2x.png" />
						{{item.follow ? '取消关注' : '关注'}}
					</div> -->
					<!-- <div class="circles-follow delete-text" v-else-if="mode_ === 2" @click="deleteCircle(item.id)">删除</div> -->
					<div class="circles-follow delete-text" v-if="mode_ === 2" @click="deleteCircle(item.id)">删除</div>
					<div class="circles-follow delete-text" v-else-if="mode_ === 3" @click="cancleCollect(item.id)">取消收藏</div>
					<div class="clearfix fl user-link" @click="goDetail(item.user.id)" v-if="item.user">
						<div class="user-image">
							<img class="poster-image-sm" :src="item.user | imgUrl('headImage')" />
						</div>
						<div class="user-info">
							<div class="user-name">{{item.user.username}}</div>
							<div class="circles-time">{{item.releaseTimeString}}  来自  {{item.channel.name}}</div>
						</div>
					</div>
				</div>
				<div class="circles-middle">
					<div class="circles-text" v-html="item.txt"></div>
					<viewer :images="multiPics_(item)">
						<ul class="circles-imgs clearfix" v-if="multiPics_(item)">
							<li v-for="(img, iIdex) in multiPics_(item)" :key="iIdex">
								<img class="poster-image" :src="img | imgUrl('url')" />
							</li>
						</ul>
					</viewer>
				</div>
				<template v-if="mode_ === 1">
					<div class="circles-bottom tr">
						<div  v-if="item.attrs" class="operation-icon operation-icon-sm operation-icon__collection" @click.stop="collection(item.id, item.attrs.isCollect, index)" :class="{'active': item.attrs.isCollect  === 'true' }">
<!--              {{item.ups | unit}}-->
            </div>
<!--						<div class="operation-icon operation-icon__dianzan" @click="resourceUp(item.id, item.attrs.isUp, index)" :class="{'active': item.attrs.isUp === 'true' }"></div>-->
            <div  v-if="item.attrs" class="operation-icon operation-icon-sm operation-icon__dianzan" :class="{'active': item.attrs.isUp === 'true'}" @click.stop="resourceUp(item.id, item.attrs.isUp, index)">
<!--              {{item.ups | unit}}-->
            </div>
            <!-- <div class="operation-icon operation-icon__pinglun" @click="showCommentFun(index)">{{item.comments  | unit}}</div> -->
			</div>
				<ssCirclesComment :value="showComment[index]" :cId="item.id" />
				</template>
			</li>
		</ul>
		<ss-no-data v-if="!finish && busy" text="数据加载中" />
		<ss-no-data v-else-if="finish && busy && value.length === 0" mode="image" text="暂无该类型圈子" />
	</div>
</template>

<script>
	import ssCirclesComment from '@/components/ss-circles-comment/ss-circles-comment.vue'
  import {mapState} from "vuex";
	export default {
		data() {
			return {
				listData: [],
				showComment: []
			}
		},
		components: {
			ssCirclesComment
		},
		props:{
			//1 正常查看看  ，2 我的圈子  3我的收藏
			mode: {
				type: [String, Number],
				default: 1
			},
			value: {
				type: Array,
				default: () => []
			},
			finish: {
				type: Boolean,
				default: false
			},
			busy: {
				type: Boolean,
				default: false
			}
		},
		watch: {
			value: {
				handler(val) {
					this.listData = val.concat();
				},
				deep: true,
				immediate: true
			},
		},
		computed: {
      ...mapState({
        userInfo: state => state.user.userInfo
      }),
			mode_() {
				return this.mode ? parseInt(this.mode) : 1;
			},
			multiPics_() {
				return (item) => {
					return (item.contentFrontVo && item.contentFrontVo.imageJson && item.contentFrontVo.imageJson.multiPics || []).map(o => o.resourcesSpaceData)
				}
			}
		},
		methods: {
			goDetail(id) {
				this.$router.push({
					path: '/circles/detail/' + id + '?userId=' + id
				})
			},
			showCommentFun(index) {
				this.$set(this.showComment, index, !this.showComment[index]);
			},
			async deleteCircle(id) {
				this.$dialog.confirm('您确定要删除圈子？', {
					okText: '确定',
					cancelText: '取消'
				}).then(async () => {
					let res1 = await this.$http('culturalDelete', {
						ids: [ id ]
					})
					if(res1.code){
						this.$emit('init', true);
					}
				})
			},
			async collection(contentId, isCollect,index) {
        isCollect = isCollect === 'false' ? false : true;
				let res = await this.$http(isCollect ? 'collectionCancel' : 'collection', {
					contentId: contentId,
					type: 1
				})
				/*if(this.isAutoCpt){
					res.code ===1 && this.contentInteractiveInfo();
				}else{
					return res.code ===1 ? true : false;
				}*/
        if(res.code ===1){
          let listData = this.$deepClone(this.listData);
          listData[index].attrs.isCollect = String(!isCollect);
          // listData[index].ups = listData[index].ups + (isUp ? -1 : 1);
          this.listData = listData;
        }
			},
			async resourceUp(contentId, isUp,index) {
        isUp = isUp === 'false' ? false : true;
				let res = await this.$http(isUp ? 'resourceCancelUp' : 'resourceUp', {
					contentId: contentId
				});
/*				if(this.isAutoCpt){
					res.code ===1 && this.contentInteractiveInfo();
				}else{
					return res.code ===1 ? true : false;
				}*/
        if(res.code ===1){
          let listData = this.$deepClone(this.listData);
          listData[index].attrs.isUp = String(!isUp);
          listData[index].ups = listData[index].ups + (isUp ? -1 : 1);
          this.listData = listData;
        }
			},
			async cancleCollect(id) {
				this.$dialog.confirm('您确定要取消收藏？', {
					okText: '确定',
					cancelText: '取消'
				}).then(async () => {
					let res = await this.collection(id, true);
					if(res.code){
						this.$emit('init', true);
					}
				})
			},
			async apimemberFollow(id, isFollow) {
				let res = await this.$http(isFollow ? 'cancelFollow' : 'follow', {
					followUserId: id
				});
				if(res.code === 1){
					let listData = this.$deepClone(this.listData);
					listData.forEach(o => {
						if(o.user.id === id){
							o.follow = !isFollow;
						}
					})
					this.listData = listData;
				}else if(res.code === 501){
          this.$dialog.confirm('您还没有登录，是否要前往登录？', {
            okText: '我再想想',
            cancelText: '确定'
          }).then(() => {
          }).catch(() => {
            this.$router.push({
              name: 'login'
            })
          })
        }
			},
			initModal() {
				this.contentInteractiveInfo();
				this.$emit('init', true);
			},
			async contentInteractiveInfo() {
				let res = await this.$http('contentInteractiveInfo', {
					contentId: this.contentId
				});
				if(res.code === 1){
					this.commentTotal = res.data.comments || 0;
				}
			},
			async comment(e, index) {
				let commentText = e.detail.value;
				if(!commentText){
					return this.$toast('评论内容不能为空');
				}
				let obj = this.listData[index] || {};
				if(!obj.id) return this.$toast('数据出错');
				let params = {
					contentId: obj.id,
					commentText: commentText
				}
				let res = await this.$http('comment', params);
				if(res.code === 1){
					this.$set(this.listData[index], 'comments', obj.comments + 1);
				}
			},
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.circles-list{
		overflow: hidden;
		& > li{
			padding: 30px 30px 0;
			background:rgba(255,255,255,1);
			border:1px solid rgba(222,222,222,1);
			& + li{
				margin-top: 18px;
			}
			.circles-bottom{
				margin-top: 42px;
				padding-bottom: 30px;
			}
			.circles-middle{
				padding-left: 63px;
				.circles-text {
					font-size: 16px;
					font-weight: 400;
					color: rgba(72, 72, 72, 1);
					line-height: 22px;

					::v-deep {
						img {
							max-width: 100% !important;
						}
					}
				}
				.circles-imgs{
					padding-right: 60px;
					li{
						margin-top: 20px;
						width: 33.3333333%;
						float: left;
						height: 169px;
						overflow: hidden;
						margin-left: 20px;
						background-position: center center;
						background-size: auto  100%;
						background-repeat: no-repeat;
						img{
							width: auto;
							height: 100%;
							margin: 0 auto;
							display: block;
						}
						&:nth-of-type(3n){
							float: right;
							margin-right: -60px;
						}
					}
				}
			}
			.user-image{
				float: left;
				img{
					width: 50px;
					height: 50px;
					border-radius: 100%;
				}
			}
			.user-link{
				cursor: pointer;
			}
			.user-info{
				padding-left: 12px;
				width: 457px;
				float: left;
				.user-name{
					font-size:18px;
					font-weight:400;
					color:rgba(32,42,48,1);
					line-height:18px;
				}
				.circles-time{
					font-size:14px;
					font-weight:400;
					color:rgba(185,185,185,1);
					line-height:18px;
					margin-top: 10px;
				}
			}
			.circles-follow{
				text-align: center;
				cursor: pointer;
				float: right;
				width:79px;
				height:30px;
				margin-top: 10px;
				background:rgba(255,255,255,1);
				border:1px solid rgba(184,210,255,1);
				border-radius:5px;
				font-size:14px;
				font-family:Source Han Sans CN;
				font-weight:400;
				color:rgba(4,96,254,1);
				line-height:28px;
				&.delete-text{
					border: none;
				}
				img{
					width: 11px;
					height: 11px;
					display: inline-block;
					vertical-align: middle;
				}
			}
		}
	}
</style>
